var map = {
	"../auth/auth.module": [
		"../../../../../src/app/auth/auth.module.ts"
	],
	"../main/main.module": [
		"../../../../../src/app/main/main.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "../../../../../src async recursive";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src async
// module id = ../../../../../src async recursive
// module chunks = 1